import { errorWrapper } from 'utility/error';

import { apiClient } from './api';
import { toImprovementAreaDomain } from './transformers/toImprovementAreaDomain';

// Fetches all improvement areas for a tenant and maps them onto the
// `Data.ImprovementArea` domain. Areas back the Improvements page filter chips
// and the create-time preselect.
async function getImprovementAreas(args: { tenantId: string }) {
  const { tenantId } = args;

  const apiCall = apiClient.ImprovementArea_GetAll({
    params: { tenantId },
  });

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to load improvement areas',
    },
    onSuccess: (dtos) => {
      const { improvementAreaDomain } = toImprovementAreaDomain({
        dtos: dtos ?? [],
      });
      return { improvementAreaDomain };
    },
  });
}

export { getImprovementAreas };
